export default {
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1024,
}
